export default "__VITE_PUBLIC_ASSET__8cf05d59__"